<div
  class="wrapper"
  *ngIf="showLength"
  [ngClass]="{
    valid: passwordValidator.passwordLength,
    invalid: !passwordValidator.passwordLength,
    submitted: submitted
  }"
>
  <span>
    <i
      class="icon icon--xxs"
      [ngClass]="{
        'icon-tick-circle': passwordValidator.passwordLength,
        'icon-error-circle': !passwordValidator.passwordLength && submitted
      }"
    ></i>
  </span>
  <small> {{ translations.passwordLength }} </small>
</div>

<div
  class="wrapper"
  *ngIf="showUppercase"
  [ngClass]="{
    valid: passwordValidator.passwordUpperCase,
    invalid: !passwordValidator.passwordUpperCase,
    submitted: submitted
  }"
>
  <span>
    <i
      class="icon icon--xxs"
      [ngClass]="{
        'icon-tick-circle': passwordValidator.passwordUpperCase,
        'icon-error-circle': !passwordValidator.passwordUpperCase && submitted
      }"
    ></i>
  </span>
  <small> {{ translations.passwordUpperCase }}</small>
</div>

<div
  class="wrapper"
  *ngIf="showLowercase"
  [ngClass]="{
    valid: passwordValidator.passwordLowerCase,
    invalid: !passwordValidator.passwordLowerCase,
    submitted: submitted
  }"
>
  <span>
    <i
      class="icon icon--xxs"
      [ngClass]="{
        'icon-tick-circle': passwordValidator.passwordLowerCase,
        'icon-error-circle': !passwordValidator.passwordLowerCase && submitted
      }"
    ></i>
  </span>
  <small> {{ translations.passwordLowerCase }}</small>
</div>

<div
  class="wrapper"
  *ngIf="showNumber"
  [ngClass]="{
    valid: passwordValidator.passwordNumber,
    invalid: !passwordValidator.passwordNumber,
    submitted: submitted
  }"
>
  <span>
    <i
      class="icon icon--xxs"
      [ngClass]="{
        'icon-tick-circle': passwordValidator.passwordNumber,
        'icon-error-circle': !passwordValidator.passwordNumber && submitted
      }"
    ></i>
  </span>
  <small> {{ translations.passwordNumber }}</small>
</div>
